/**
 * Client-side step-up claim cache for cookie sessions (no body/memory JWT).
 * Proof of record remains BE-issued `stepUpUntil` (cookie JWT and/or verify body).
 * Dual mode may also seed this when body token is applied.
 *
 * Lives under shared/session so refresh coordinator can clear on rotate (G26)
 * without depending on the auth feature folder.
 */

/** Match `ADMIN_STEP_UP_SKEW_MS` in adminStepUpProof (ADM-TKT-0505). */
const STEP_UP_SKEW_MS = 30_000;

let cachedStepUpUntil: number | null = null;

/** Record BE-issued step-up expiry (epoch ms) after verify / dual apply. */
export function setAdminStepUpUntilClaim(stepUpUntil: number | null): void {
  cachedStepUpUntil =
    stepUpUntil != null && Number.isFinite(stepUpUntil) ? stepUpUntil : null;
}

/** Cookie-session claim — may be set when memory JWT is absent. */
export function getAdminStepUpUntilClaim(): number | null {
  return cachedStepUpUntil;
}

export function isAdminStepUpClientClaimValid(nowMs: number = Date.now()): boolean {
  if (cachedStepUpUntil == null || !Number.isFinite(cachedStepUpUntil)) {
    return false;
  }
  return nowMs <= cachedStepUpUntil + STEP_UP_SKEW_MS;
}

/** Clears FE step-up markers. Call on logout / session clear / access refresh rotate. */
export function clearAdminStepUpClientCache(): void {
  cachedStepUpUntil = null;
}
